import type {
    FC
} from "react";
import ColorPage, {
    getColorToc
} from "./color";
import SpacingPage, {
    getSpacingToc
} from "./spacing";
import TypographyPage, {
    getTypographyToc
} from "./typography";
import type {
    DocsTranslate
} from "../../anatomy/types";
import type {
    DocsTocItem
} from "../../components/toc";

export const FOUNDATION_PAGES: Record<string, {
    getToc: (t: DocsTranslate) => Array<DocsTocItem>;
    Page: FC;
}> = {
    "/foundations/typography": {
        getToc: getTypographyToc,
        Page: TypographyPage
    },
    "/foundations/spacing": {
        getToc: getSpacingToc,
        Page: SpacingPage
    },
    "/foundations/color": {
        getToc: getColorToc,
        Page: ColorPage
    }
};
